import instance from './instance';

import { logout } from "../actions/sessionActions";

export const instanceAction = (apiUrl, method, data, apiHeaders = {}) => {
  switch (method) {
    case 'post': return dispatch => {
      return instance.post(apiUrl, data, { headers: apiHeaders }).then((response) => {
        return Promise.resolve(response);
      }).catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default: return Promise.reject(err);
        }
      });
    }
    case 'put': return dispatch => {
      return instance.put(apiUrl, data, { headers: apiHeaders }).then((response) => {
        return Promise.resolve(response);
      }).catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default: return Promise.reject(err);
        }
      });
    }
  }
  return false;
}